module.exports = __webpack_public_path__ + "img/c00_buildingtechstonewall_Normal_ua.3b1db9e5.webp";